/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "zvjvdrbgkebyckknnugx"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2anZkcmJna2VieWNra25udWd4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2Mjk5NTYsImV4cCI6MjA3OTIwNTk1Nn0.5NwXz7SXpV-6U1ERTwJlL7SQOE-oHmlgpw5F0mCdZeY"